import React, { useState, useEffect } from 'react';
import { makeStyles, Button, TextField } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import { Formik, Form } from 'formik';
import FormikSelectField from 'formik-material-fields/lib/FormikSelectField';
import * as Yup from 'yup';
import GreenButton from '../../Shared/GreenButton';
import {toDateFormatWithT} from '../../../Helpers/dateHelper'
import {toDateFormatWithoutT} from '../../../Helpers/dateHelper'
import { generateNewId } from '../../../Helpers/generalHelper';

export default function CreateEditRestrictionDrawer(props) {
    const classes = useStyles();
    const [workstation, setWorkstation] = useState(null)
    const [start, setStart] = useState(null)
    const [end, setEnd] = useState(null)
    const [type, setType] = useState(null)

    useEffect(() => {
        if (props.restriction) {
            setStart(props.restriction.start)
            setEnd(props.restriction.end)
        }
        else{
            setStart(null)
            setEnd(null)
        }
    }, [props.restriction]);

    function saveRestriction() {
        let tempRestrictions = []
        var i;
        for (i = 0; i < props.workstation.restrictions.length; i++) {
            tempRestrictions.push(Object.assign({}, props.workstation.restrictions[i]))
        }

        if (props.restriction) {
            if (workstation) {
                tempRestrictions.find(x => x.id === props.restriction.id).workstation = workstation
            }
            if (start) {
                tempRestrictions.find(x => x.id === props.restriction.id).start = toDateFormatWithoutT(start)
            }
            if (end) {
                tempRestrictions.find(x => x.id === props.restriction.id).end = toDateFormatWithoutT(end)
            }
            if (type) {
                tempRestrictions.find(x => x.id === props.restriction.id).type = type
            }
        }
        else {           
            let newRestriction = { "id": generateNewId(tempRestrictions), "workstation": workstation, "start": toDateFormatWithoutT(start), "end": toDateFormatWithoutT(end), "type": type }
            tempRestrictions.push(newRestriction)
        }

        if (props.checkRestrictionOrderOverlapping(null, null, workstation, tempRestrictions, props.order.productionOrders)) {
            props.actions.setRestrictions(tempRestrictions)
        }
    }

    function restrictionTypeChanged(e) {
        setType(e.target.value)
    }

    function workstationChanged(e) {
        setWorkstation(e.target.value)
    }

    function startDateChanged(date) {
        setStart(date.target.value)
        if (props.restriction) {
            props.restriction.start = date.target.value
        }
    }

    function endDateChanged(date) {
        setEnd(date.target.value)
        if (props.restriction) {
            props.restriction.end = date.target.value
        }
    }    

    let workstationData = props.workstation.workstations.map(x => { return ({ label: "Production line " + x.id, value: x.id }) })
    let restrictionTypeData = props.workstation.restrictionTypes.filter(y => y.id !== 4).map(x => { return ({ label: x.description, value: x.id }) })

    return <Drawer variant="temporary" className={classes.drawer} anchor='right' open={props.drawerOpen} classes={{ paper: clsx({ [classes.drawerOpen]: props.drawerOpen, [classes.drawerClose]: !props.drawerOpen, }), }} onClose={() => props.openDrawer(false)} transitionDuration={500}>
        <div className={classes.drawerBody}>
            <div className={classes.header}>
                <div className={classes.title}>{props.restriction ? "Edit restriction" : "Create restriction"}</div>
                <div className={classes.close}>
                    <Button className={classes.closeButton} onClick={() => props.openDrawer(false)}><CloseIcon></CloseIcon></Button>
                </div>
            </div>
            <div className={classes.body}>
                <Formik
                    initialValues={
                        props.restriction ? {
                            workstation: props.restriction.workstation,
                            type: props.restriction.type
                        } : {}}
                    validationSchema={Yup.object().shape(props.restriction ? {} : {
                        workstation: Yup.string().required('Workstation is required'),
                        type: Yup.string().required('Type is required')
                    })}
                >
                    {({ isValid, touched }) => (
                        <Form autoComplete="off" className={classes.form}>
                            <div className={classes.restrictionInfo}>
                                <div className={classes.label} >Workstation</div>
                                <FormikSelectField name="workstation" className={classes.formikSelectField} onChange={(e) => workstationChanged(e)} options={workstationData} />
                                <div className={classes.dates}>
                                    <div className={classes.from}>
                                        <div className={classes.fromtill}>
                                            Start restriction
                    </div>
                                        <div>
                                            <TextField className={classes.datePicker}
                                                id="datetime-local"
                                                variant="outlined"
                                                type="datetime-local"
                                                format="dd-MM-yyyy HH:mm"
                                                onChange={date => startDateChanged(date)}
                                                size='small'
                                                value={toDateFormatWithT(props.restriction ? props.restriction.start : start ? start : new Date)}
                                            />
                                        </div>
                                    </div>
                                    <div className={classes.till}>
                                        <div className={classes.fromtill}>
                                            End restriction
                    </div>
                                        <div>
                                            <TextField className={classes.datePicker}
                                                id="datetime-local"
                                                variant="outlined"
                                                type="datetime-local"
                                                format="dd-MM-yyyy HH:mm"
                                                onChange={date => endDateChanged(date)}
                                                size='small'
                                                value={toDateFormatWithT(props.restriction ? props.restriction.end : end ? end : new Date)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className={classes.label} >Restriction type</div>
                                <FormikSelectField name="type" className={classes.formikSelectField} onChange={(e) => restrictionTypeChanged(e)} options={restrictionTypeData} />
                            </div>
                            <div className={classes.saveButton}>
                                <GreenButton disabled={!isValid || (Object.entries(touched).length === 0) && !props.restriction} text={"SAVE RESTRICTION"} onClick={saveRestriction}></GreenButton>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    </Drawer >
}

const useStyles = makeStyles(() => ({
    drawerBody: {
        width: "100%",
        height: "100%",
        background: 'linear-gradient(#EFEFEF,#FFFFFF)',
        padding: "20px",
        paddingRight: "5px",
        paddingTop: "10px",
        boxSizing: "border-box"
    },
    closeButton: {
        float: 'right',
        "&:hover": {
            background: "#EFEFEF"
        },
        paddingRight: "0px !important",
        width: "25px !important",
        height: "25px !important",
        minWidth: "0px !important",
    },
    drawerOpen: {
        width: "30%",
    },
    drawerClose: {
        width: 0
    },
    close: {
        width: "20%",
        float: 'left',
    },
    title: {
        float: 'left',
        width: "80%",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        marginTop: "10px"
    },

    header: {
        width: "100%",
        height: "5%",
        marginBottom: "20px"
    },
    formikSelectField: {
        width: "97%",
        height: "40px",
        borderRadius: "5px",
        backgroundColor: "white",
        border: "1px solid #c1c2be",
        paddingLeft: "10px",
        "& .MuiInput-root": {
            height: "40px",
        },
        "& .MuiInput-underline:before": {
            borderBottom: "none !important"
        },
        "& .MuiInput-underline:after": {
            borderBottom: "none !important"
        },
        "& .MuiFormHelperText-root.Mui-error": {
            marginTop: "10px",
            height: "20px",
            backgroundColor: "rgb(1,1,1,0)",
            display: 'block'
        },
        marginBottom: "10px"
    },
    label: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#020100",
    },
    saveButton: {
        width: "100%",
        textAlign: "center",
        marginTop: "30px"
    },
    fromtill: {
        display: 'block',
        color: '#020100',
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
    },
    datePicker: {
        borderRadius: "6px",
        backgroundColor: "white",
        "& input": {
            fontSize: "14px !important",
            fontFamily: "Lato, sans-serif !important",
        },
        marginBottom: '10px',
        width: "90%"

    },
    from: {
        width: "50%",
        float: "left",
    },
    till: {
        width: "50%",
        float: "left",
    },
    dates: {
        weight: "100%",
        height: "50px"
    }

}));